import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import AdminPage from './pages/AdminPage';
import UserPage from './pages/UserPage';
import AgeVerification from './pages/legal/AgeVerification';
import TermsOfService from './pages/legal/TermsOfService';
import TransactionLaw from './pages/legal/TransactionLaw';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const ProtectedRoute = ({ children, allowedRole }) => {

    useEffect(() => {
      // Simulate fetching auth status and role
      const authStatus = true; // replace with your actual auth logic
      const roleFromStorage = localStorage.getItem('role');

      setIsAuthenticated(authStatus);
      setUserRole(roleFromStorage);
      setLoading(false);
    }, []);

    if (loading) {
      return <div style={{ textAlign: 'center', padding: '50px' }}>読み込み中...</div>;
    }

    if (!userRole) {
      return <Navigate to="/login" />;
    }

    if (allowedRole && userRole !== allowedRole) {
      return <Navigate to={userRole === 'admin' ? '/admin' : '/user'} />;
    }

    return children;
  };
  return (
    <Router>
      <Routes>
        <Route 
          path="/" 
          element={
            isAuthenticated ? (
              <Navigate to={userRole === 'admin' ? '/admin' : '/user'} />
            ) : (
              <Navigate to="/login" />
            )
          } 
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        
        {/* Admin Routes */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/user-management" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/inquiry-list" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/payment-transactions" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/payment-settings" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/payment-history" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/point-costs" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/sent-messages" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/inbox-messages" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/email-management" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/board-posts" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/annual-income" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/occupation-management" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/profile-settings" 
          element={
            <ProtectedRoute allowedRole="admin">
              <AdminPage />
            </ProtectedRoute>
          } 
        />
        
        {/* User Routes */}
        <Route 
          path="/user" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/dashboard" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/profile-settings" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/profile-search" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/favorite-list" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/unread-emails" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/sent-emails" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/received-emails" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/message-board-posting" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/message-board-search" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/inquiry" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/inquiry-history" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/points-usage" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/user/point-purchase" 
          element={
            <ProtectedRoute allowedRole="user">
              <UserPage />
            </ProtectedRoute>
          } 
        />
        
        {/* Legal Pages */}
        <Route path="/legal/age-verification" element={<AgeVerification />} />
        <Route path="/legal/terms-of-service" element={<TermsOfService />} />
        <Route path="/legal/transaction-law" element={<TransactionLaw />} />
        <Route path="/legal/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default App; 